import { Icon } from '@tcweb/connect-ui';
import { Component, createMemo, Show } from 'solid-js';
import { CheckboxMenuItem } from './types';

interface ControlMenuCheckboxRowProps {
  item: CheckboxMenuItem;
  isIndeterminate: boolean;
}

export const ControlMenuCheckboxRow: Component<ControlMenuCheckboxRowProps> = (
  props
) => {
  const checkboxValue = createMemo(() => props.item.value() ?? false);
  const checkboxIndeterminate = createMemo(() => props.isIndeterminate);

  const LabelSpan = (): ReturnType<Component> => (
    <span
      class="whitespace-nowrap flex-1 text-base-content"
      data-testid={'control-menu-dropdown-option-' + props.item.id}
    >
      {props.item.label}
    </span>
  );

  return (
    <>
      <modus-wc-checkbox
        value={checkboxValue()}
        indeterminate={checkboxIndeterminate()}
        disabled={props.item.disabled}
      />
      <Show when={props.item.icon}>
        <Show
          when={typeof props.item.icon === 'string'}
          fallback={props.item.icon}
        >
          <Icon
            icon={props.item.icon as string}
            class="flex min-w-5 min-h-5 text-base-content"
          />
        </Show>
      </Show>
      <Show when={props.item.tooltip} fallback={<LabelSpan />}>
        <modus-wc-tooltip content={props.item.tooltip}>
          <LabelSpan />
        </modus-wc-tooltip>
      </Show>
    </>
  );
};
